module.exports = __webpack_public_path__ + "static/media/Enchantress.fdadd300.png";